export const AwaitCustomerApprove = 0
export const AwaitExecutorApprove = 1
export const ExecutorEdited = 2
export const ExecutorDeclined = 3
export const ExecutorApproved = 4
export const Stopped = 5
export const Finished = 6
export const Closed = 7
export const Expired = 8
export const InProgress = 9

export const GetStatusText = status => {
    switch (status) {
        case AwaitExecutorApprove:
            return 'Подтверждён заказчиком'
        case ExecutorEdited:
            return 'Изменён поставщиком'
        case ExecutorDeclined:
            return 'Отклонён поставщиком'
        case ExecutorApproved:
            return 'Подтверждён поставщиком'
        case Stopped:
            return 'Приостановлен поставщиком'
        case Finished:
            return 'Выполнен'
        case Closed:
            return 'Закрыт'
        case Expired:
            return 'Просрочен'
        case InProgress:
            return 'Поставка'
        default:
            return 'Не подтверждён'
    }
}

export const GetStatusVariant = status =>{
    switch (status) {
        case AwaitExecutorApprove:
            return 'blue-grey darken-4 white--text'
        case ExecutorEdited:
            return 'warning white--text'
        case ExecutorDeclined:
            return 'red white--text'
        case ExecutorApproved:
            return 'green white--text'
        case Stopped:
            return 'secondary lighten-3 white--text'
        case Finished:
            return 'lime darken-4 white--text'
        case Closed:
            return 'green darken-4 white--text'
        case Expired:
            return 'orange darken-3 white--text'
        case InProgress:
            return 'green darken-3 white--text'
        default:
            return 'blue-grey white--text'
    }
}